import { APP_PLATFORMS } from "../../../../../../../constants"
import generateShortID from "../../../../../../../utils"

export const PADDING_CONFIG = {
  padding_config: {
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
  },
}

export const MARGIN_CONFIG = {
  margin_config: {
    bottom: 8,
    left: 8,
    right: 8,
    top: 8,
  },
}

export const TEXT_CONFIG = {
  color: "#242424",
  font_family: "sans-serif",
  ...MARGIN_CONFIG,
  ...PADDING_CONFIG,
  size: 16 /* min: 12, max: 24 */,
  is_adaptive_text: true,
  style: "normal" /* "normal" || "bold" || "italic" */,
  text: "Text",
  localized_messages: {},
}

export const IMAGE_ONLY_REDIRECTION_CONFIG = {
  action: "dismiss",
  activity: "",
  is_deep_link: false,
}

export const BUTTON_CONFIG = {
  action_config: {
    action: "dismiss" /* "dismiss" || "redirect" || "cancel" */,
    activity: "",
    is_deep_link: false,
  },
  borders: {
    radius: 0,
    stroke_color: "#000000",
    stroke_width: 0,
  },
  color: "#27a4f2",
  id: "",
  ...MARGIN_CONFIG,
  ...PADDING_CONFIG,
  text_config: {
    ...TEXT_CONFIG,
    /**
     * "center" || "left" || "right"
     * @todo: add support for changing alignment in the config toolbar
     */
    alignment: "center",
  },
  visibility: 1,
}

export const ANIMATION_CONFIG = {
  duration: 400,
  enabled: true,
  type: "cycle" /* "cycle" || "bounce" */,
}

export const CONSTANT_CONFIGS = {
  language_attribute: "",
  localization_enabled: false,
}

export const POSITION_ENUM = {
  TOP: "TOP",
  BOTTOM: "BOTTOM",
  LEFT: "LEFT",
  RIGHT: "RIGHT",
}

export const BACKGROUND_OFFSET_CONFIG = {
  pos_offset: {
    skid: 0,
    distance: 0,
  },
}

export const CONTAINER_CONFIG = {
  bg_color: "#017DFD",
  opacity: 1,
  position: POSITION_ENUM.BOTTOM,
  border: {
    color: "#045343",
    width: 0,
  },
  button_position: "right" /* "center" || "left" || "right" */,
  corners: {
    enabled: true,
    width: 4,
  },
  dimmed_background: false,
  dismiss_outside_touch: false,
  layout_type: "default",
  view_id: "",
  animation: {
    ...ANIMATION_CONFIG,
  },
  ...BACKGROUND_OFFSET_CONFIG,
}

export const ACTION_BUTTON_CONFIG = {
  color: "#fff",
  visibility: 1,
  text_config: {
    ...TEXT_CONFIG,
    text: "Title",
    size: 17,
    style: "normal",
    color: "#002845",
    font_family: "sans-serif",
  },
  image:
    "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",
  description_config: {
    text: "Description",
    size: 14,
    style: "normal",
    color: "#A1AFBB",
    font_family: "sans-serif",
  },
  action_config: {
    action: "dismiss",
    activity: "",
    is_deep_link: false,
  },
  __id: generateShortID(),
}

// New Configs

export const PADDING = {
  enable_padding: true,
  padding: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
}

export const MARGIN = {
  enable_margin: true,
  margin: {
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
  },
}

export const BORDER_CONFIG = {
  enable_border: true,
  border: {
    radius: 10,
    color: "#000000",
    width: 0,
    style: "solid",
  },
}

export const FONT_CONFIG = {
  font: {
    family: "sans-serif",

    /**
     * min: 12, max: 24
     */
    size: 18,
    is_adaptive_text: true,
    /**
     * "normal" || "italic" || "oblique"
     */
    style: "normal",

    /**
     * "bold" || "normal"
     */
    weight: "normal",
  },
}

export const GENERIC_TEXT_CONFIG = {
  text: "Text",
  color: "#000000",

  /**
   * "left" || "center" || "right" || "justify"
   */
  alignment: "left",
  ...FONT_CONFIG,
}

export const GENERIC_ICON_CONFIG = {
  enable_icon: false,
  icon: {
    path: "https://storage.googleapis.com/apx_frontend-assets/web-nudge.icon.png",
    height: 40,
    width: 40,

    /**
     * "start" || "center" || "end"
     */
    alignment: "center",
    ...BORDER_CONFIG,
  },
}

export const TITLE_ICON = GENERIC_ICON_CONFIG

export const TITLE = {
  enable_title: true,
  title: {
    ...GENERIC_TEXT_CONFIG,
    text: "Find your brand",
    color: "#FFFFFF",
    font: {
      ...GENERIC_TEXT_CONFIG.font,
      size: 18,
      weight: "bold",
    },
    ...MARGIN,
    margin: {
      ...MARGIN.margin,
      top: 12,
      bottom: 12,
    },
    ...PADDING,
    ...TITLE_ICON,
  },
}

export const DESCRIPTION = {
  enable_description: true,
  description: {
    ...GENERIC_TEXT_CONFIG,
    text: "Can't describe what you are looking for? Take or upload a photo to find similar items",
    color: "#FFFFFF",
    font: {
      ...GENERIC_TEXT_CONFIG.font,
      size: 14,
    },
    ...MARGIN,
    margin: {
      ...MARGIN.margin,
      bottom: 12,
    },
    ...PADDING,
  },
}

export const DIM_BACKGROUND_CONFIG = {
  enable_dimbackground: false,
  dimbackground: {
    color: "#000000",
    opacity: 0.8,
  },
}

export const DEFAULT_SECONDARY_ICON_CONFIG = {
  enable: true,
  color: "#FFFFFF",
  fill_color: "#E5E5E5",

  /**
   * "filled" || "normal" || "custom"
   */
  type: "normal",
  path: "",
  offset_top: 8,
  offset_right: 8,
  offset_left: 8,
  height: 18,
  width: 18,
  shape: "circle",
}

export const CLOSE_CONFIG = {
  enable_close_button: true,
  close_button: {
    ...DEFAULT_SECONDARY_ICON_CONFIG,
    action: "dismiss",
  },
}

export const SCROLL_CONFIG = {
  enable_scroll: false,
  scroll: {
    height: 300,
    ...BORDER_CONFIG,
  },
}

export const SHADOW_CONFIG = {
  enable_shadow: false,
  shadow: {
    color: "#000000",
    offset_x: 0,
    offset_y: 0,
    blur_radius: 8,
    spread_radius: 8,
  },
}

export const GRADIENT_CONFIG = {
  enable_gradient: false,
  gradient: {
    direction: "to right",
    colors: ["#5D5FEF", "#935F5F"],
  },
}

export const MEDIA_ICON_CONFIG = {
  ...GENERIC_ICON_CONFIG,
  icon: {
    ...GENERIC_ICON_CONFIG.icon,
    ...PADDING,
    ...MARGIN,
  },
}

export const BACKGROUND_IMAGE_CONFIG = {
  enable_background_image: false,
  background_image: {
    mask_opacity: 0.5,
    mask_color: "#ffffff",
  },
}

export const EMBED_CONFIG = {
  enable_embed: false,
  embed: {
    html: "",
  },
}

export const AUDIO_CONFIG = {
  enable_audio: true,
}

export const MEDIA_VIDEO_CONFIG = {
  enable_video: false,
  video: {
    path: "https://www.w3schools.com/tags/movie.mp4",
    height: 9,
    width: 16,
    ...BORDER_CONFIG,
    border: {
      ...BORDER_CONFIG.border,
      radius: 0,
    },
    ...EMBED_CONFIG,
    ...AUDIO_CONFIG,
  },
}

export const POSITION_CONFIG = {
  position: {
    /**
     * IN_APP : "top_left" || "top_center" || "top_right" || "center" || "bottom_left" || "bottom_center" || "bottom_right"
     * new-inline: "top" || "left" || "right" || "bottom"
     */
    position: "center",
    enable_offset: true,
    offset: {
      skid: 0,
      distance: 0,
    },
  },
}

export const DIRECTION_CONFIG = {
  direction: {
    /**
     * The alignment of the media and the non-media (text + buttons) elements with respect to each other
     * "horizontal" || "vertical"
     */
    nudge: "vertical",

    /**
     * The alignment of the non-media (text + buttons) elements with respect to each other
     * "horizontal" || "vertical"
     */
    non_media: "vertical",

    /**
     * The alignment of the buttons with respect to each other
     * "horizontal" || "vertical"
     */
    buttons: "horizontal",
  },
}

/**
 * 1. Dismiss
 *   - `type` and `action`
 * 2. Cancel
 *   - `type` and `action`
 * 3. Redirect
 *   - `type` and `action`
 *   a. Activity
 *    ```json
 *    "is_deep_link": false,
 *    "activity": "<fill>",
 *    "deep_link": { "uri": "any", "intent_action": "any" },
 *    "internal_redirection": []
 *    ```
 *
 *   b. Deep Link
 *    ```json
 *    "is_deep_link": true,
 *    "activity": "any",
 *    "deep_link": { "uri": "<fill>", "intent_action": "<fill>" },
 *    "internal_redirection": []
 *    ```
 *
 *   c. Key-Value Pairs (Internal Redirection)
 *    ```json
 *    "is_deep_link": false,
 *    "activity": "any",
 *    "deep_link": { "uri": "any", "intent_action": "any" },
 *    "internal_redirection": null
 *    ```
 */
export const ACTION_CONFIG = {
  enable_action: true,
  action: {
    /**
     * "dismiss" || "redirect" || "cancel"
     */
    type: "dismiss", // for WebSDK
    action: "dismiss", // for WebViews

    url: "",
    is_external: true,
    is_ir: false,
    is_within: false,
    callback: "",

    // WebView Specific
    is_deep_link: false,
    activity: "",
    deep_link: { uri: "" },
    internal_redirection: [],
  },
}

export const MEDIA_IMAGE_CONFIG = {
  enable_image: false,
  image: {
    path: "https://images.unsplash.com/photo-1674754666581-4e6657392655?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2832&q=80",
    height: 9,
    width: 16,
    ...BORDER_CONFIG,
    border: {
      ...BORDER_CONFIG.border,
      radius: 0,
    },
    ...BACKGROUND_IMAGE_CONFIG,
    ...ACTION_CONFIG,
  },
}

export const NEW_BUTTON_CONFIG = {
  slot: 1,
  color: "#017DFD",
  ...ACTION_CONFIG,
  ...BORDER_CONFIG,
  border: {
    ...BORDER_CONFIG.border,
    radius: 4,
    color: "#FFFFFF",
  },
  ...MARGIN,

  ...PADDING,
  padding: {
    ...PADDING.padding,
    left: 24,
    right: 24,
    top: 8,
    bottom: 8,
  },

  enable_text: true,
  text: {
    ...GENERIC_TEXT_CONFIG,
    color: "#FFFFFF",
    font: { ...GENERIC_TEXT_CONFIG.font, size: 14 },
    ...MARGIN,
    ...PADDING,
  },
}

export const NEW_BUTTONS_CONFIG = {
  enable_buttons: true,
  buttons_count: 5,
  buttons: {
    enable_top: true,
    top: [],
    enable_center: true,
    center: [],
    enable_bottom: true,
    bottom: [],
  },
}

export const PIP_BUTTON_CONFIG = {
  enable_pip_button: false,
  pip_button: {
    ...DEFAULT_SECONDARY_ICON_CONFIG,
    type: "normal",
  },
}

export const PIP_CONFIG = {
  /**
   * "PIP" || "mini"
   */
  mode: "mini",
  pip: {
    enable_toggles: true,
  },
}

export const ARROW_CONFIG = {
  enable_arrow: true,
  arrow: {
    /**
     * "normal" || "round" || "narrow" || "large" || "small" || "wide"
     */
    type: "normal",
    color: "#F0F9FF",
    ...BORDER_CONFIG,
  },
}

export const NEW_ANIMATION_CONFIG = {
  enable_animation: true,
  animation: {
    /**
     * "cycle" ||
     */
    type: "cycle",
    duration: 500,
  },
}

export const TARGET_CONFIG = {
  target: {
    id: "",
    enable_retry: true,
    retry: {
      interval: 2000,
      max_retries: 5,
    },
    is_content_based: false,
    content: {},
  },
}

export const NEW_INLINE_POSITION_CONFIG = {
  position: {
    /**
     * "top" || "right" || "left" || "bottom"
     */
    position: "bottom",
    enable_offset: true,
    offset: {
      skid: 0,
      distance: 0,
    },
  },
}

export const DISMISS_ACTIONS_CONFIG = {
  enable_dismiss_actions: true,
  dismiss_actions: {
    outside_touch: true,
    target_touch: true,
  },
}

// Badges Configs

export const BADGE_POSITION_CONFIG = {
  position: {
    /**
     * @type string
     * @description "TL" || "T" || "TR" || "L"  || "C" || "R" || "BL" || "B" || "BR"
     */
    position: "TR",
    offset: {
      x: 0,
      y: 0,
    },
  },
}

export const BADGE_BACKGROUND_IMAGE_CONFIG = {
  enable_image: false,
  image: {
    /**
     * @type string
     * @description "assets" | "url"
     */
    type: "url",

    /**
     * @type string
     */
    path: "https://images.unsplash.com/photo-1674754666581-4e6657392655?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2832&q=80",
  },
}

export const BADGE_BORDER_CONFIG = {
  /**
   * @type boolean
   */
  enable_border: true,
  border: {
    /**
     * @type string
     */
    color: "#000000",
    corners: {
      top_left: 0,
      top_right: 0,
      bottom_right: 0,
      bottom_left: 0,
    },
    width: {
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },
  },
}

export const BADGE_SHAPE_CONFIG = {
  shape: {
    /**
     * @type string
     */
    color: "#FF0000",
    /**
     * @type string
     * @description "rectangle" | "circle"
     */
    type: "circle",
    ...BADGE_BORDER_CONFIG,
  },
}

export const BADGE_BACKGROUND_CONFIG = {
  /**
   * @type boolean
   */
  enable_background: true,
  background: {
    height: 24,
    width: 24,
    ...BADGE_BACKGROUND_IMAGE_CONFIG,
    ...BADGE_SHAPE_CONFIG,
  },
}

export const BADGE_LABEL_CONFIG = {
  /**
   * @type boolean
   */
  enable_label: false,
  label: { ...MARGIN, ...GENERIC_TEXT_CONFIG },
}

export const BADGE_ICON_CONFIG = {
  /**
   * @type boolean
   */
  enable_icon: false,
  icon: {
    /**
     * @type string
     * @description "path" | "url"
     */
    type: "url",

    /**
     * @type string
     */
    path: "https://storage.googleapis.com/apx_frontend-assets/web-nudge.icon.png",

    /**
     * @type string
     * @description "left" | "right"
     */
    position: "right",
    width: 20,
    height: 20,
    ...MARGIN,
  },
}

export const BADGE_SHADOW_CONFIG = {
  /**
   * @type boolean
   */
  enable_shadow: false,
  shadow: {
    /**
     * @type string
     */
    color: "#FFFFFF",
    offset_x: 2,
    offset_y: 2,
    spread_radius: 2,
  },
}

export const BADGE_SHINE_ONE_LINE_CONFIG = {
  /**
   * @type number
   */
  width: 5,
}

export const BADGE_ANIMATION_CONFIG = {
  /**
   * @type boolean
   */
  enable_animation: false,
  animation: {
    /**
     * @type string
     * @description "shine" | "ripple" | "fade" | "shake"
     */
    type: "shine",

    // Duration of each animation cycle
    duration_millis: 700,

    // Delay between each animation set
    delay_millis: 0,

    // Number of animation cycles per animation set
    intra_count: 0,

    // Number of animation sets
    inter_count: 0,

    // Ripple Animation
    ripple: {
      area: 20,

      /**
       * @type string
       * @description ARGB Value
       */
      color: "#FFFFFF",

      /**
       * @type number
       * @description 0 to 1. consider only iff `shape` is `rectangle`
       */
      corner_radius: 0,

      /**
       * @type string
       * @description "rectangle" | "circle"
       */
      shape: "rectangle",
    },

    // Fade Animation
    fade: {
      /**
       * @type number
       * @description 0 to 1
       */
      opacity: 0,
    },

    // Shake Animation
    shake: {
      /**
       * @type string
       * @description "vertical" | "horizontal"
       */
      direction: "horizontal",
    },

    // Shine Animation
    shine: {
      /**
       * @type string
       * @description "to_top_right" | "to_bottom_right" | "to_top_left" | "to_bottom_left"
       */
      direction: "to_top_right",

      /**
       * @type string
       * @description ARGB Value
       */
      color: "#FFFFFF",
      /**
       * @type number
       */
      lines_gap: 10,
      /**
       * @type {Array<BADGE_SHINE_ONE_LINE_CONFIG>}
       */
      lines: [BADGE_SHINE_ONE_LINE_CONFIG],
    },
  },
}

export const BADGE_SCROLL_CONFIG = {
  /**
   * @type boolean
   */
  enable_auto_scroll: false,
  auto_scroll: {
    /**
     * @type number
     */
    duration_millis: 1000,
    /**
     * @type string
     * @description  "to_right" | "to_left" | "to_top" | "to_bottom"
     */
    direction: "to_right",
    /**
     * @type number
     */
    horizontal_gap: 5,
  },
}

export const ONE_BADGE_VARIANT_CONFIG = {
  ...BADGE_LABEL_CONFIG,
  ...BADGE_ICON_CONFIG,
}

export const ADD_BADGE_VARIANT_CONFIG = {
  ...ONE_BADGE_VARIANT_CONFIG,
  enable_label: true,
  label: {
    ...BADGE_LABEL_CONFIG.label,
    text: "New",
  },
}

export const INITIAL_BADGE_STATE = {
  view_find_timeout: 30000,
  view_find_interval: 2000,
  badge: {
    ...BADGE_POSITION_CONFIG,
    ...BADGE_BACKGROUND_CONFIG,

    /**
     * @type {Array<ONE_BADGE_VARIANT_CONFIG>}
     */
    content: [ONE_BADGE_VARIANT_CONFIG],
    ...BADGE_ANIMATION_CONFIG,
    ...BADGE_SHADOW_CONFIG,
    ...BADGE_SCROLL_CONFIG,
  },
}

// Badge Templates initial configs

export const SIMPLE_BADGE_VARIANT_CONFIG = {
  view_find_timeout: 30000,
  view_find_interval: 2000,
  badge: {
    ...BADGE_POSITION_CONFIG,
    ...BADGE_BACKGROUND_CONFIG,
    background: {
      ...BADGE_BACKGROUND_CONFIG.background,
      width: 18,
      height: 18,
      shape: {
        ...BADGE_SHAPE_CONFIG.shape,
        type: "circle",
        color: "#DC0404",
      },
    },
    content: [ONE_BADGE_VARIANT_CONFIG],
    ...BADGE_ANIMATION_CONFIG,
    ...BADGE_SHADOW_CONFIG,
    ...BADGE_SCROLL_CONFIG,
  },
}

export const STATIC_BADGE_VARIANT_CONFIG = {
  view_find_timeout: 30000,
  view_find_interval: 2000,
  badge: {
    ...BADGE_POSITION_CONFIG,
    ...BADGE_BACKGROUND_CONFIG,
    background: {
      ...BADGE_BACKGROUND_CONFIG.background,
      width: 34,
      height: 16,
      shape: {
        ...BADGE_SHAPE_CONFIG.shape,
        border: {
          ...BADGE_BORDER_CONFIG.border,
          corners: {
            top_left: 8,
            top_right: 8,
            bottom_left: 8,
            bottom_right: 8,
          },
        },
        type: "rectangle",
        color: "#D64A40",
      },
    },
    content: [
      {
        ...ONE_BADGE_VARIANT_CONFIG,
        enable_label: true,
        label: {
          ...BADGE_LABEL_CONFIG.label,
          font: {
            ...GENERIC_TEXT_CONFIG.font,
            size: 8,
          },
          color: "#FFFFFF",
          alignment: "center",
          text: "NEW",
        },
      },
    ],
    ...BADGE_ANIMATION_CONFIG,
    ...BADGE_SHADOW_CONFIG,
    ...BADGE_SCROLL_CONFIG,
  },
}

export const LABEL_ICON_BADGE_VARIANT_CONFIG = {
  view_find_timeout: 30000,
  view_find_interval: 2000,
  badge: {
    ...BADGE_POSITION_CONFIG,
    ...BADGE_BACKGROUND_CONFIG,
    background: {
      ...BADGE_BACKGROUND_CONFIG.background,
      width: 48,
      height: 18,
      shape: {
        ...BADGE_SHAPE_CONFIG.shape,
        border: {
          ...BADGE_BORDER_CONFIG.border,
          corners: {
            top_left: 8,
            top_right: 8,
            bottom_left: 8,
            bottom_right: 8,
          },
        },
        type: "rectangle",
        color: "#7EB5C9",
      },
    },
    content: [
      {
        ...ONE_BADGE_VARIANT_CONFIG,
        enable_label: true,
        label: {
          ...BADGE_LABEL_CONFIG.label,
          text: "Label",
          font: { ...GENERIC_TEXT_CONFIG.font, size: 11 },
        },
        enable_icon: true,
        icon: {
          ...BADGE_ICON_CONFIG.icon,
          width: 9,
          height: 9,
          path: "https://storage.googleapis.com/apx_frontend-assets/flag.png",
          ...MARGIN,
          margin: { ...MARGIN.margin, left: 5 },
        },
      },
    ],
    ...BADGE_ANIMATION_CONFIG,
    ...BADGE_SHADOW_CONFIG,
    ...BADGE_SCROLL_CONFIG,
  },
}

export const OFFER_BADGE_VARIANT_CONFIG = {
  view_find_timeout: 30000,
  view_find_interval: 2000,
  badge: {
    ...BADGE_POSITION_CONFIG,
    ...BADGE_BACKGROUND_CONFIG,
    background: {
      ...BADGE_BACKGROUND_CONFIG.background,
      width: 72,
      height: 72,
      enable_image: true,
      image: {
        path: "https://storage.googleapis.com/apx_frontend-assets/offer.png",
        type: "url",
      },
    },
    content: [
      {
        ...ONE_BADGE_VARIANT_CONFIG,
        enable_label: true,
        label: {
          ...BADGE_LABEL_CONFIG.label,
          text: "Offer\n8%",
          font: { ...GENERIC_TEXT_CONFIG.font, size: 18 },
          alignment: "center",
          color: "#FFFFFF",
        },
      },
    ],
    ...BADGE_ANIMATION_CONFIG,
    ...BADGE_SHADOW_CONFIG,
    ...BADGE_SCROLL_CONFIG,
  },
}

export const DISCOUNT_BADGE_VARIANT_CONFIG = {
  view_find_timeout: 30000,
  view_find_interval: 2000,
  badge: {
    ...BADGE_POSITION_CONFIG,
    ...BADGE_BACKGROUND_CONFIG,
    background: {
      ...BADGE_BACKGROUND_CONFIG.background,
      width: 94,
      height: 24,
      shape: {
        ...BADGE_SHAPE_CONFIG.shape,
        border: {
          ...BADGE_BORDER_CONFIG.border,
          corners: {
            top_left: 13,
            top_right: 13,
            bottom_left: 13,
            bottom_right: 13,
          },
        },
        type: "rectangle",
        color: "#D64A40",
      },
    },
    content: [
      {
        ...ONE_BADGE_VARIANT_CONFIG,
        enable_label: true,
        label: {
          ...BADGE_LABEL_CONFIG.label,
          font: {
            ...GENERIC_TEXT_CONFIG.font,
            size: 12,
          },
          color: "#FFFFFF",
          alignment: "center",
          text: "50 ₹ discount",
          margin: { left: 6, right: 6, top: 0, bottom: 0 },
        },
      },
    ],
    ...BADGE_ANIMATION_CONFIG,
    ...BADGE_SHADOW_CONFIG,
    ...BADGE_SCROLL_CONFIG,
  },
}

// Coachmarks Configs

export const NEW_COACHMARKS_OFFSET_CONFIG = {
  enable_offset: true,
  offset: {
    x: 0,
    y: 0,
  },
}

export const NEW_COACHMARKS_LIST_BUTTONS = {
  color: "#FFFFFF",
  text: {
    text: "Yes",
    alignment: "center",
    color: "#017DFD",
    font: {
      ...FONT_CONFIG.font,
      size: 14,
    },
  },
  position: {
    position: "L",
  },
  enable_padding: true,
  padding: {
    top: 6,
    bottom: 6,
    left: 12,
    right: 12,
  },
  ...ACTION_CONFIG,
  ...MARGIN,
  ...BORDER_CONFIG,
}

export const NEW_COACHMARKS_BUTTON = {
  enable_buttons: true,
  coachmark_buttons: {
    direction: "H",
    alignment: "C",
    list: [
      NEW_COACHMARKS_LIST_BUTTONS,
      {
        ...NEW_COACHMARKS_LIST_BUTTONS,
        color: "#",
        text: {
          text: "No",
          alignment: "center",
          color: "#ffffff",
          font: {
            ...FONT_CONFIG.font,
            size: 14,
          },
        },
        enable_border: true,
        border: {
          radius: 10,
          color: "#000000",
          width: 1.5,
          style: "solid",
        },
        enable_margin: true,
        margin: {
          bottom: 0,
          left: 10,
          right: 0,
          top: 0,
        },
      },
    ],
  },
}

export const NEW_COACHMARKS_DELTA_CONFIG = {
  shape: "circle",
  delta_circle: 0,
  delta_rect: {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  },
}

export const NEW_COACHMARKS_RIPPLE = {
  enable_ripple: true,
  ripple: {
    opacity: 0.8,
    color: "#000000",
    ripple_type: "outward",
    duration: 1500,
    width: 250,
  },
}

export const NEW_COACHMARKS_HIGHLIGHTER = {
  inner_highlighter: {
    enable_border: true,
    border: {
      width: 2,
      color: "#000000",
      style: "solid",
      opacity: 0.8,
      radius: 0,
    },
    ...NEW_COACHMARKS_DELTA_CONFIG,
  },
}

export const NEW_COACHMARKS_BACKGROUND = {
  outer_highlighter: {
    color: "#017DFD",
    opacity: 0.8,
    offset: {
      x: 0,
      y: 0,
    },
    shape: "circle",
    delta_circle: 0,
    delta_rect: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    },
  },
}
export const NEW_COACHMARKS_IMAGE = {
  enable_image: true,
  image: {
    height: 50,
    width: 50,
    type: "url",
    path: "https://storage.googleapis.com/apx_frontend-assets/panda.png",
    enable_border: false,
    border: {
      radius: 0,
      color: "#FFFFFF",
      width: 1,
      style: "solid",
    },
    enable_offset: true,
    offset: {
      x: 0,
      y: 0,
    },
    position: "R",
    aspect_ratio: {
      height: 1,
      width: 1,
    },
  },
}

export const NEW_COACHMARKS_ARROW = {
  enable_arrow: true,
  arrow: {
    angle: 180,
    height: 50,
    width: 50,
    type: "url",
    path: "https://storage.googleapis.com/apx_frontend-assets/arrow-2.png",
    enable_border: false,
    border: {
      radius: 0,
      color: "#FFFFFF",
      width: 1,
      style: "solid",
    },
    enable_offset: true,
    offset: {
      x: 0,
      y: 0,
    },
    position: "T",
    aspect_ratio: {
      height: 10,
      width: 10,
    },
  },
}

export const NEW_COACHMARKS_CONTENTS = {
  content: {
    position: "T",
    enable_title: true,
    title: {
      ...TITLE.title,
      text: "New! See what's coming up",
      color: "#ffffff",
      font: {
        ...GENERIC_TEXT_CONFIG.font,
        size: 16,
      },
    },
    enable_description: true,
    description: {
      ...DESCRIPTION.description,
      text: "Helpful cards show you whats happening soon",
      color: "#ffffff",
      font: {
        ...GENERIC_TEXT_CONFIG.font,
        size: 12,
      },
      margin: {
        bottom: 14,
        left: 0,
        right: 0,
        top: 12,
      },
    },
    enable_margin: true,
    margin: {
      bottom: 16,
      left: 0,
      right: 0,
      top: 0,
    },
    enable_offset: true,
    offset: {
      x: 20,
      y: -50,
    },
    ...NEW_COACHMARKS_BUTTON,
  },
}

export function getRetryAndIntervalKeys(platform, isBadge = false) {
  switch (platform) {
    case APP_PLATFORMS.ios: {
      return {
        timeout: 30000,
        find_interval: 2000,
        webview_wait_interval: 1000,
        element_find_interval: 1000,
        retry_count: 5,
      }
    }

    case APP_PLATFORMS.android: {
      if (isBadge) {
        return {
          view_find_timeout: 30000,
          view_find_interval: 2000,
          webview_wait_interval: 0,
          element_find_interval: 1000,
          retry_count: 5,
        }
      } else {
        return {
          timeout: 30000,
          find_interval: 2000,
          webview_wait_interval: 0,
          element_find_interval: 1000,
          retry_count: 5,
        }
      }
    }

    default:
      return {}
  }
}
